
import React from "react";
import { useState, useEffect, useMemo, useRef } from "react";
import { TrendingUp, TrendingDown, Minus, ArrowUpDown, ArrowUp, ArrowDown, RotateCcw } from "lucide-react";
import { TEXTES_COMPREHENSION, nomDuTexte, rangDuTexte } from "./evaluationConfig";


function TestSpecifique({testSpecifique, EvalNat,evalBilan, handleItemClick}) {

  
  const labelAutomatismes = useMemo(() => {
  
    return EvalNat.questions
      .filter(question => question.type_label === "Automatisme")
      .reduce((acc, question) => {
        acc[question.question_num] = question.nom_label;
        return acc;
      }, {});
  }, [EvalNat]); // Les dépendances sont les questions de EvalNat

  const labelProblèmes = useMemo(() => {

    return EvalNat.questions
      .filter(question => question.type_label === "Résolution de problèmes")
      .reduce((acc, question) => {
        acc[question.question_num] = question.nom_label;
        return acc;
      }, {});
  }, [EvalNat]); // Les dépendances sont les questions de EvalNat

  // Pour les labels simples (comme Automatisme et Problèmes)
const labelLexique = useMemo(() => {
  if (!EvalNat) return {};
  return EvalNat.questions
    .filter(question => question.type_label === "Lexique")
    .reduce((acc, question) => {
      acc[question.question_num] = question.nom_label;
      return acc;
    }, {});
}, [EvalNat]);


// Chaque texte a ses propres Q01, Q02… : la clé est « texte + numéro » (« Arachné Q01 »), celle des
// tuiles et du détail ; indexé par le seul numéro, les textes s'écrasaient et aucune tuile ne trouvait
// son libellé (09/10/2026).
const labelComprehensionEcrite = useMemo(() => {
  if (!EvalNat) return {};
  return EvalNat.questions
    .filter(question => question.type_label.startsWith("Compréhension de l'écrit"))
    .reduce((acc, question) => {
      acc[`${nomDuTexte(question.type_label)} ${question.question_num}`] = question.nom_label;
      return acc;
    }, {});
}, [EvalNat]);



const labelCompetencesLangagieres = useMemo(() => {
  if (!EvalNat) return {};
  return EvalNat.questions
    .filter(question => question.type_label === "Compétences langagières et linguistiques")
    .reduce((acc, question) => {
      acc[question.question_num] = question.nom_label;
      return acc;
    }, {});
}, [EvalNat]);




    const [statistiques, setStatistiques] = useState({});
    const [activeItemId, setActiveItemId] = useState(null);
   const [activeQuestion, setActiveQuestion] = useState('Q1');
   const [sortByProgression, setSortByProgression] = useState(null); // null, 'asc', 'desc'



   const calculerStatistiques = (elevesReponses, testSpecifique) => {
 
    let stats = {};
    
    // Les textes de compréhension de l'écrit, d'hier et d'aujourd'hui (evaluationConfig)
    const comprehensionEcriteCategories = TEXTES_COMPREHENSION.map((t) => t.nom);

    elevesReponses.forEach(eleve => {
        if (eleve.reponses) {
            // Si c'est ComprehensionEcrite, traiter toutes les sous-catégories
            if (testSpecifique === "ComprehensionEcrite") {
                comprehensionEcriteCategories.forEach(category => {
                    if (eleve.reponses[category]) {
                        Object.entries(eleve.reponses[category]).forEach(([question, data]) => {
                            // Créer une clé unique pour chaque question
                            const questionKey = `${category} ${question}`;
                            
                            if (!stats[questionKey]) {
                                stats[questionKey] = { 
                                    reussites: [], 
                                    echecs: [], 
                                    question_num: question,
                                    category: category 
                                };
                            }
                            
                            const eleveData = { 
                                classe: eleve.classe_nom, 
                                nom: eleve.nom_eleve, 
                                réponse: data?.réponse || '' 
                            };
                            
                            if (data.score === 1) {
                                stats[questionKey].reussites.push(eleveData);
                            } else {
                                stats[questionKey].echecs.push(eleveData);
                            }
                        });
                    }
                });
            } 
             // Cas spécifique pour CompetencesLangagieres
        else if (testSpecifique === "CompetencesLangagieres") {
            // Les questions sont dans eleve.reponses.Compétence
            if (eleve.reponses.Compétence) {
                Object.entries(eleve.reponses.Compétence).forEach(([question, data]) => {
                    if (!stats[question]) {
                        stats[question] = { 
                            reussites: [], 
                            echecs: [], 
                            question_num: question 
                        };
                    }
                    
                    const eleveData = { 
                        classe: eleve.classe_nom, 
                        nom: eleve.nom_eleve, 
                        réponse: data?.réponse || '' 
                    };
                    
                    if (data.score === 1) {
                        stats[question].reussites.push(eleveData);
                    } else {
                        stats[question].echecs.push(eleveData);
                    }
                });
            }
        } else {
                // Traitement normal pour les autres catégories
                if (eleve.reponses[testSpecifique]) {
                    Object.entries(eleve.reponses[testSpecifique]).forEach(([question, { score, réponse }]) => {
                        if (!stats[question]) {
                            stats[question] = { reussites: [], echecs: [], question_num: question };
                        }
                        
                        const eleveData = { 
                            classe: eleve.classe_nom, 
                            nom: eleve.nom_eleve, 
                            réponse: réponse || '' 
                        };
                        
                        if (score === 1) {
                            stats[question].reussites.push(eleveData);
                        } else {
                            stats[question].echecs.push(eleveData);
                        }
                    });
                }
            }
        }
    });
    
    return stats;
}
    // A OPTIMISER !!!

    const calculerStatistiquesevalBilan = (elevesReponses, testSpecifique) => {
   
      let stats = {};
      // Pour chaque élève
      let tache = ""
      if(testSpecifique==="Automatismes"){
        tache="Automatisme"
      }
      else{
        tache="Résolution de problèmes"
      }

     
      elevesReponses.forEach(eleve => {
        // Assurez-vous que l'élève a des réponses pour le test spécifique
   
        if (eleve.reponses && eleve.reponses[tache]) {
         
          Object.entries(eleve.reponses[tache]).forEach(([question, { score }]) => {
      
            let question_num = eleve.reponses[tache][question].question_num
            if (!stats[question]) {
              stats[question] = { reussites: [], echecs: [] , question_num : question_num ,id : question };
            }
            
            const eleveData = {classe: eleve.classe_nom, nom: eleve.nom_eleve, réponse: eleve.reponses[tache][question]?.réponse || '' };
            if (score === 1) {
              stats[question].reussites.push(eleveData);
            } else {
              stats[question].echecs.push(eleveData);
            }
          });
        }
      });
  
      return stats;
  }

    useEffect(() => { 

     
        
        const statsEvalNat = calculerStatistiques(EvalNat.eleves_reponses, testSpecifique);
        const statsEvalBilan = evalBilan ? calculerStatistiquesevalBilan(evalBilan, testSpecifique) : {};
        
       
        const statsCombinés = {
          evalNat : statsEvalNat,
          evalBilan : statsEvalBilan
        }

        setStatistiques(statsCombinés);

      
      }, [EvalNat, evalBilan, testSpecifique]);


    const handleClick = (statsbilan, statsnat , id , question_num) => {
       let objEvalBilan = {}   
       if(evalBilan){
        objEvalBilan = {
            statsbilan : statsbilan,
            statsnat: statsnat,
            question_id : id,
            bilan : true,
            question_num : question_num, 
          }
          handleItemClick(objEvalBilan);
       }
      else {
        handleItemClick(statsnat)
      }
        setActiveItemId(id);
    }

    const handleEvalNatClick = (obj , id) => { 
      handleItemClick(obj)
       setActiveItemId(id);
       setActiveQuestion(id)
   }

    const getLabel = (label, testSpecifique) => {
  switch(testSpecifique) {
    case "Automatismes":
      return labelAutomatismes[label];
    case "Problèmes":
      return labelProblèmes[label];
    case "Lexique":
      return labelLexique[label];
    case "ComprehensionEcrite":
      return labelComprehensionEcrite[label];
    case "CompetencesLangagieres":
      return labelCompetencesLangagieres[label];
    default:
      return testSpecifique;
  }
};
   const handleQuestionClick = (questionId) => {
    setActiveQuestion(questionId);
  };
    // Récupérer les questions de la source de données active
  const activeStats = evalBilan ? statistiques.evalBilan : statistiques.evalNat;

  let statsBilan = undefined ;

  // Total des élèves pour le calcul du pourcentage (tous les élèves, pas seulement ceux qui ont répondu)
  const totalEleves = EvalNat.eleves_reponses?.length || 0;


  const toggleSort = () => {
    setSortByProgression(prev => prev === null ? 'asc' : prev === 'asc' ? 'desc' : prev === 'desc' ? 'asc' : null);
  };

  // Texte par texte (compréhension : Arachné Q01 à Q10, puis Sommeil Q01…), puis par numéro.
  const sortByQuestionNum = (a, b) => {
    const parTexte = rangDuTexte(a[1].category) - rangDuTexte(b[1].category);
    if (parTexte !== 0) return parTexte;
    const numA = parseInt((a[1].question_num || a[0]).replace(/\D/g, '')) || 0;
    const numB = parseInt((b[1].question_num || b[0]).replace(/\D/g, '')) || 0;
    return numA - numB;
  };

  const sortedEntries = activeStats ? (() => {
    const entries = Object.entries(activeStats);
    if (!sortByProgression) return [...entries].sort(sortByQuestionNum);
    return [...entries].sort((a, b) => {
      const pctA = totalEleves > 0 ? Math.round((a[1].reussites.length / totalEleves) * 100) : 0;
      const pctB = totalEleves > 0 ? Math.round((b[1].reussites.length / totalEleves) * 100) : 0;
      return sortByProgression === 'asc' ? pctA - pctB : pctB - pctA;
    });
  })() : [];


  // Ref pour éviter la boucle infinie : on lit les valeurs courantes sans les mettre en deps
  const latestRef = useRef({ sortedEntries, evalBilan, statistiques, handleClick, handleEvalNatClick });
  latestRef.current = { sortedEntries, evalBilan, statistiques, handleClick, handleEvalNatClick };

  // Auto-sélectionner la première question au chargement ou changement de type
  useEffect(() => {
    const { sortedEntries, evalBilan, statistiques, handleClick, handleEvalNatClick } = latestRef.current;
    if (sortedEntries.length > 0) {
      const [question, statsNat] = sortedEntries[0];
      if (evalBilan && statistiques.evalBilan?.[question]) {
        handleClick(statistiques.evalBilan, statistiques.evalNat, question, statistiques.evalBilan[question].question_num);
      } else if (!evalBilan) {
        handleEvalNatClick({ question, reussites: statsNat.reussites, echecs: statsNat.echecs }, question);
      }
    }
  }, [statistiques, testSpecifique]);

    return (
      <div className=" border-slate-700 ">
        {/* Bouton de tri par réussite (uniquement pour ProgressBarNat, sans bilan) */}
        {activeStats && !evalBilan && (
          <div className="sticky top-0 z-10 bg-white/90 backdrop-blur-sm px-4 py-2 border-b border-gray-200 flex justify-end gap-2">
            <button
              onClick={toggleSort}
              className={`flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-medium transition ${
                sortByProgression
                  ? 'bg-blue-100 text-blue-700 hover:bg-blue-200'
                  : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
              }`}
            >
              {sortByProgression === 'asc' ? <ArrowUp className="w-3.5 h-3.5" /> : sortByProgression === 'desc' ? <ArrowDown className="w-3.5 h-3.5" /> : <ArrowUpDown className="w-3.5 h-3.5" />}
              Réussite {sortByProgression === 'asc' ? '↑' : sortByProgression === 'desc' ? '↓' : ''}
            </button>
            {sortByProgression && (
              <button
                onClick={() => setSortByProgression(null)}
                className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-medium transition bg-gray-100 text-gray-600 hover:bg-gray-200"
              >
                <RotateCcw className="w-3.5 h-3.5" />
                Q1, Q2...
              </button>
            )}
          </div>
        )}
        {sortedEntries.map(([question, statsNat]) => {
          // Initialiser pourcentageEvalBilan à 0 ou null par défaut
          let pourcentageEvalBilan = 0;
          // Si evalBilan est défini et contient la question actuelle, calculez le pourcentage
          if(evalBilan && statistiques.evalBilan[question]) {
             statsBilan = statistiques.evalNat[statistiques.evalBilan[question].question_num];
            // Utiliser le total des élèves au lieu de reussites + echecs
            pourcentageEvalBilan = totalEleves > 0 ? Math.round((statsBilan.reussites.length / totalEleves) * 100) : 0;
          }
          else{
            pourcentageEvalBilan = undefined;
          }
          // Si evalBilan n'est pas défini ou ne contient pas la question actuelle, ne faites rien ou définissez pourcentageEvalBilan à null

          // Calculez pourcentageEvalNat avec le total des élèves (pas seulement ceux qui ont répondu)
          const pourcentageEvalNat = totalEleves > 0 ? Math.round((statsNat.reussites.length / totalEleves) * 100) : 0;          
          // Retournez le ProgressBar avec les props appropriées
  
          return (
            <React.Fragment key={question}>
           {pourcentageEvalBilan !== undefined  && <div>
              <ProgressBar 
                onClick={() =>
                   handleClick(statistiques.evalBilan, statistiques.evalNat , question, 
                    statistiques.evalBilan[question].question_num )}
                percentage={pourcentageEvalNat }
                pourcentageReference={pourcentageEvalBilan}
                label={statistiques.evalBilan[question].question_num}
                testSpecifique={testSpecifique}
                isActive={activeItemId === question}
                labelAutomatisme={labelAutomatismes}
                labelProblèmes={labelProblèmes}
                labelLexique={labelLexique}
                labelCompetencesLangagieres={labelCompetencesLangagieres}
                labelComprehensionEcrite={labelComprehensionEcrite}
              />
            </div>  }
            {!evalBilan && <ProgressBarNat
                onClick={() => handleEvalNatClick({ question, reussites: statsNat.reussites, echecs: statsNat.echecs }, question)}
                pourcentageReference={pourcentageEvalNat}
                label={question}
                isActive={activeQuestion === question}
                labelText={getLabel(question, testSpecifique)}
              />
            }     
            </React.Fragment>  
          );
        })}
      </div>
    );
};


export default TestSpecifique;




export const ProgressBar = ({ percentage, label, onClick, isActive, testSpecifique, pourcentageReference,
   labelAutomatisme, labelProblèmes, labelLexique, labelCompetencesLangagieres, labelComprehensionEcrite }) => {

  const diffPercentage = percentage - pourcentageReference;

  const getEvolutionColor = (diff) => {
    if (diff > 0) return 'text-emerald-600';
    if (diff < 0) return 'text-red-500';
    return 'text-gray-500';
  };

  const getEvolutionIcon = (diff) => {
    if (diff > 0) return <TrendingUp className="w-4 h-4" />;
    if (diff < 0) return <TrendingDown className="w-4 h-4" />;
    return <Minus className="w-4 h-4" />;
  };

  const getColorForPercentage = (pct) => {
    if (pct < 40) return 'bg-gradient-to-r from-red-400 via-red-500 to-red-600';
    if (pct < 70) return 'bg-gradient-to-r from-amber-400 via-amber-500 to-amber-600';
    return 'bg-gradient-to-r from-emerald-400 via-emerald-500 to-emerald-600';
  };

  const getLabel = () => {
    if (testSpecifique === "Automatismes" && labelAutomatisme) return labelAutomatisme[label];
    if (testSpecifique === "Problèmes" && labelProblèmes) return labelProblèmes[label];
    if (testSpecifique === "Lexique" && labelLexique) return labelLexique[label];
    if (testSpecifique === "CompetencesLangagieres" && labelCompetencesLangagieres) return labelCompetencesLangagieres[label];
    if (testSpecifique === "ComprehensionEcrite" && labelComprehensionEcrite) return labelComprehensionEcrite[label];
    return '';
  };

  return (
    <button
      onClick={onClick}
      className={`w-full text-left px-3 py-2.5 transition-all duration-200 border-b border-gray-100 last:border-b-0
        ${isActive
          ? 'bg-gradient-to-r from-blue-100 to-cyan-100 border-l-4 !border-l-blue-600 shadow-sm'
          : 'hover:bg-gray-50'
        }
      `}
    >
      <div className="flex items-center justify-between mb-1">
        <div className="flex items-center gap-2 min-w-0">
          <span className={`text-[10px] font-bold px-1.5 py-0.5 rounded ${isActive ? 'bg-blue-600 text-white' : 'bg-gray-200 text-gray-600'}`}>
            {label}
          </span>
          <p className="text-xs text-gray-600 truncate">{getLabel()}</p>
        </div>
        <div className={`flex items-center gap-1 text-xs font-semibold shrink-0 ${getEvolutionColor(diffPercentage)}`}>
          {getEvolutionIcon(diffPercentage)}
          {diffPercentage > 0 ? '+' : ''}{diffPercentage}%
        </div>
      </div>

      <div className="space-y-1">
        <div className="flex items-center gap-1.5">
          <span className="text-[10px] text-gray-400 w-7">Nat.</span>
          <div className="flex-1 h-1 bg-gray-200 rounded-full overflow-hidden">
            <div
              className={`h-full ${getColorForPercentage(pourcentageReference)} rounded-full transition-all duration-500`}
              style={{ width: `${pourcentageReference}%` }}
            />
          </div>
          <span className="text-[10px] text-gray-500 w-7 text-right">{pourcentageReference}%</span>
        </div>
        <div className="flex items-center gap-1.5">
          <span className="text-[10px] text-gray-400 w-7">Bilan</span>
          <div className="flex-1 h-1 bg-gray-200 rounded-full overflow-hidden">
            <div
              className={`h-full ${getColorForPercentage(percentage)} rounded-full transition-all duration-500`}
              style={{ width: `${percentage}%` }}
            />
          </div>
          <span className="text-[10px] text-gray-500 w-7 text-right">{percentage}%</span>
        </div>
      </div>
    </button>
  );
};

const ProgressBarNat = ({ pourcentageReference, label, onClick, isActive, labelText }) => {

  const getColorForPercentage = (pct) => {
    if (pct < 40) return 'bg-gradient-to-r from-red-400 via-red-500 to-red-600';
    if (pct < 70) return 'bg-gradient-to-r from-amber-400 via-amber-500 to-amber-600';
    return 'bg-gradient-to-r from-emerald-400 via-emerald-500 to-emerald-600';
  };

  return (
    <button
      onClick={onClick}
      className={`w-full text-left px-3 py-2.5 transition-all duration-200 border-b border-gray-100 last:border-b-0
        ${isActive
          ? 'bg-gradient-to-r from-blue-100 to-cyan-100 border-l-4 !border-l-blue-600 shadow-sm'
          : 'hover:bg-gray-50'
        }
      `}
    >
      <div className="flex items-center justify-between mb-1">
        <div className="flex items-center gap-2 min-w-0">
          <span className={`text-[10px] font-bold px-1.5 py-0.5 rounded ${isActive ? 'bg-blue-600 text-white' : 'bg-gray-200 text-gray-600'}`}>
            {label}
          </span>
          <p className="text-xs text-gray-600 truncate">{labelText}</p>
        </div>
        <span className={`text-xs font-bold shrink-0 ${
          pourcentageReference < 40 ? 'text-red-600' : pourcentageReference < 70 ? 'text-amber-600' : 'text-emerald-600'
        }`}>
          {pourcentageReference}%
        </span>
      </div>

      <div className="flex items-center gap-1.5">
        <div className="flex-1 h-1.5 bg-gray-200 rounded-full overflow-hidden">
          <div
            className={`h-full ${getColorForPercentage(pourcentageReference)} rounded-full transition-all duration-500`}
            style={{ width: `${pourcentageReference}%` }}
          />
        </div>
      </div>
    </button>
  );
};




  